/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplicationV2BCSDetail {
    getFixupPrototypeFunction() { return AppSecopsApplicationV2BCSDetail.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplicationV2BCSDetail>): AppSecopsApplicationV2BCSDetail {
        let obj = Object.assign(new AppSecopsApplicationV2BCSDetail(), model);
        AppSecopsApplicationV2BCSDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplicationV2BCSDetail>): AppSecopsApplicationV2BCSDetail {
        if (!model) return null;
        return AppSecopsApplicationV2BCSDetail.newInstance(<AppSecopsApplicationV2BCSDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplicationV2BCSDetail) {
        if (!obj) return;

        models.AppSecopsApplicationV2BCSDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplicationV2BCSDetail): boolean {
        Object.setPrototypeOf(obj, AppSecopsApplicationV2BCSDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.score === undefined) {
            this.score = 0;
        }
        if (this.bcs_question_version === undefined) {
            this.bcs_question_version = 0;
        }
        if (this.version === undefined) {
            this.version = 0;
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (this.selected) {
            for (let val of this.selected) {
                models.AppSecopsApplicationV2BCSSelectedItem.fixupPrototype(val);
            }
        }
    }

    /**
     * BCS score (20-100)
     */
    score: number;

    /**
     * BCS questions config version
     */
    bcs_question_version: number;

    /**
     * Submission version
     */
    version: number;

    /**
     * Submitted answers
     */
    selected: Array<models.AppSecopsApplicationV2BCSSelectedItem>;

    /**
     * When this submission was created
     */
    created_at: Date;

    /**
     * Name of the user who created the submission
     */
    created_by: string;

}
